import React from "react";
import { cn } from "@ndd/ui";
import type { XmlItemRating } from "../../../../shared/analysis-types";
import { scorecardRatingDisplay } from "../../lib/analysis-display";
import { Badge, highlightMark } from "../badge";

interface RatingBadgeProps {
  rating: Exclude<XmlItemRating, "na">;
  className?: string;
}

// The badge keeps its fixed 80px slot so item labels line up down the
// scorecard. Under the always theme the highlighter sits on the word, not the
// slot: the badge drops its own mark (bg-none) and the inner span draws it
// (ADR-0004, 2026-10-22 amendment). With the theme off neither has a mark.
export function RatingBadge({ rating, className }: RatingBadgeProps) {
  const { badgeVariant, label } = scorecardRatingDisplay[rating];

  return (
    <Badge
      variant={badgeVariant}
      size="md"
      className={cn("w-20 justify-center bg-none", className)}
    >
      <span className={cn("px-(--highlight-px,0px)", highlightMark(badgeVariant))}>
        {label}
      </span>
    </Badge>
  );
}
